import styles from './style.module.css';
import FieldMasked from "react-input-mask";
import Field from "skin/entry/cmp/field";
import usePhone from './hook';
import Code from './code';

export default function Phone({ value = '', setValue, err }) {
	const { num, onNumChange, status, request, submitPhone } = usePhone(value, setValue);
	const s = status.type;
	return <>
		<div className={styles.group}>
			<FieldMasked disabled={s === 'wait'} mask="+7 (999) 999 99-99" value={num} onChange={onNumChange}>
				{props =>
					<Field {...props}
						className={num ? null : styles.empty}
						text={s ? null : 'Подтвердить'}
						onClick={s ? null : ((s !== 'wait' && num.length === 11) ? request : null)}
						err={err}
						label='Номер телефона'
						autoComplete='mobile tel'
						icon='phone'
						type='layer1'
						placeholder='Введите номер'
					/>}
			</FieldMasked>
			{status.message ? <span className={styles.msg}>{status.message}</span> : null}
		</div>
		<div className={styles.group}>
			{s === 'ok' && <Code ok={value === num} phone={num} submitPhone={submitPhone} />}
		</div>
	</>
}